@for (option of normalizedOptions; track trackByValue($index, option)) {
  <ppl-checkbox
    #checkbox="pplCheckbox"
    [disabled]="disabled"
    [value]="!!value && value.includes(option.value)"
    [autofill]="changes.includes(option.value)"
    (valueChange)="onCheck(option.value, $event.checked)">
    <span
      [class.changes]="checkbox.autofill"
      class="label"
      >{{ option.label }}</span
    >
  </ppl-checkbox>
}
